import React from 'react';
import Panel from '../components/Panel';
import Input from '../components/Input';
import InputFile from '../components/InputFile';
import * as actions from '../store/actions/index';
import store from '../store';
import BlueprintPanelFooter from '../blocks/BlueprintPanelFooter';
import _ from 'lodash';
import InputSelect from '../components/InputSelect';
import languages from '../lib/languages';
import {connect} from 'react-redux';
import config from '../config';

class BlueprintSubmitPanel extends React.Component {

  constructor(props) {
    super(props);

    let values = props.blueprint.values || {};
    this.state = {
      data: _.reduce(props.block.fields, (container, field) => {
        let name = `${props.block.name}.${field.name}`;
        if (_.isEmpty(values[name])) {
          container[name] = {
            data: field.defaultValue,
          };
        } else {
          container[name] = values[name];
        }
        return container;
      }, {}),
      dirtyFields: new Set(),
    };
    this.handleNext = this.handleNext.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updateValue = this.updateValue.bind(this);
    this.finalizeData = this.finalizeData.bind(this);
  }

  finalizeData() {
    let userName = this.props.user.nickname || this.props.user.id;
    let {block, blueprint} = this.props;

    let newAudit = _.reduce(Array.from(this.state.dirtyFields),
        (container, dirtyField) => {
          let field = _.find(block.fields,
              (item) => `${block.name}.${item.name}` === dirtyField);

          container[dirtyField] = {
            update: {
              action_date: new Date(),
              by: userName,
              details: `You have received a blueprint submission from ${userName} on task  ${field.label} in the group ${block.title} for project ${blueprint.name}.`,
            },
          };
          return container;
        }, {});

    return {
      data: _.reduce(this.state.data, (container, value, key) => {
        if (!_.isEmpty(value) && typeof value.data !== 'undefined') {
          container[key] = value;
        }
        return container;
      }, {}),
      audit: newAudit,
    };
  }

  handleNext() {
    let {data, audit} = this.finalizeData();
    this.props.onNext(data, audit);
  }

  handleSubmit() {
    let {data, audit} = this.finalizeData();
    this.props.onSubmit(data, audit);
  }

  updateValue(name, value) {

    let params = {
      data: value,
      submitted: new Date(),
      audit: {
        action: 'update',
        action_date: new Date(),
        by: this.props.user.id,
      },
    };

    if (!this.props.user.isAdmin) {
      params.last_user = this.props.user.id;
    }
    this.setState({
      data: Object.assign({}, this.state.data, {
        [name]: Object.assign({}, this.state.data[name], params),
      }),
      dirtyFields: this.state.dirtyFields.add(name),

    });
  }

  handleMultiSelectChange(name, value) {
    this.updateValue(name, _.map(value, (item) => {
      return {label: item.label, value: item.value};
    }));
  }

  handleFormChange(name, value) {
    console.log(value)
    this.updateValue(name, value);
  }

  handleTranslatedFieldUpload(name, languageCode, file) {
    let translatedLabels = this.state.data[name].data ||
        [];
    let value = _.remove(translatedLabels, (item) => {
      return item && item.lng === languageCode;
    });
    value = value.length > 0 ? value[0] : {lng: languageCode, val: []};
    value.val = [file];
    translatedLabels.push(value);
    this.updateValue(name, translatedLabels);
  }

  handleTranslatedFieldChange(name, languageCode, translatedValue) {
    let translatedLabels = this.state.data[name].data ||
        [];
    let value = _.remove(translatedLabels, (item) => {
      return item && item.lng === languageCode;
    });
    value = value.length > 0 ? value[0] : {lng: languageCode, val: []};
    value.val = translatedValue;
    translatedLabels.push(value);
    this.updateValue(name, translatedLabels);
  }

  renderTranslatedField(
      name, type, label, labelWhenEmpty = 'No Language Selected',
      sample = undefined) {
    let languageSource = this.state.data['languages.languages'] ||
        this.props.blueprint.values['languages.languages'] || {};
    let fields = (languageSource.data || []).map(
        ({label, value}) => {
          let initialValue = _.find(this.state.data[name].data ||
              [], (item) => {
            return item && item.lng === value;
          }) || {lng: value, val: null};
          switch (type) {
            case 'translated-field-file':
              return (<InputFile labelIndented
                                 label={label}
                                 value={initialValue.val ?
                                     initialValue.val[0] :
                                     null}
                                 onChange={this.handleTranslatedFieldUpload.bind(
                                     this, name, initialValue.lng)}
                                 key={value}
              />);
            default:
              return (<Input labelIndented
                             label={label}
                             value={initialValue.val || ''}
                             onChange={this.handleTranslatedFieldChange.bind(
                                 this, name, initialValue.lng)}
                             key={value}
              />);
          }

        });

    let noLanguageSelected = fields.length === 0;

    if (noLanguageSelected) {
      fields = [
        (
            <div style={{
              fontStyle: 'italic',
              color: '#cccc',
              textAlign: 'center',
              padding: '20px',
              paddingTop: '0',
            }} key='no-selected-language'>{labelWhenEmpty}</div>
        ),
      ];
    }
    if(sample && !sample.includes('//')){
      sample = `https://s3-${config.apiGateway.REGION}.amazonaws.com/${config.s3.APP_BUCKET}${sample}`;
    }

    return [
      <div className="row"
           key='label'>
        <div className="col-lg-4 col-md-4 pull-left">
          <div>
            <label>{label}</label>
          </div>
          {
            sample ? (
                <div className="Download-here" key='download-link' style={{textAlign: 'left',paddingLeft:'20px'}}>
                  <a href={sample} target="_blank"><i>* Download sample file from
                    here</i></a>
                </div>
            ) : null
          }
        </div>

      </div>,
      <div style={noLanguageSelected ? null : {paddingTop: '20px'}}>
        {fields}
      </div>,
    ];
  }

  renderField({
                name,
                type,
                label,
                defaultValue,
                options = {},
                noResultsText = '',
                addText = 'Add :label',
                placeholder = undefined,
                labelWhenEmpty = undefined,
                sample = undefined,
              }) {
    name = `${this.props.block.name}.${name}`;
    if (typeof this.state.data[name] === 'undefined') {
      this.state.data[name] = {
        data: defaultValue,
      };
    }

    if (['select', 'multi-select'].includes(type)) {
      options =
          _.isArray(options) ?
              options :
              _.transform(options, (container, value, key) => {
                container.push({
                  label: value,
                  value: key,
                });
                return container;
              }, []);
    }
    switch (type) {
      case 'multi-text':
        let value = this.state.data[name].data || [];
        value = _.isArray(value) ? value : {label:value,value};
        return (
            <InputSelect value={value}
                         label={label}
                         creatable
                         multi
                         onChange={this.handleMultiSelectChange.bind(this,
                             name)}
                         key={name}
                         noResultsText={noResultsText}
                         placeholder={placeholder}
                         promptTextCreator={(label) =>
                             addText.replace(':label', label)}
            />);
      case 'select':
        return (
            <InputSelect value={this.state.data[name].data}
                         options={options}
                         label={label}
                         clearable={false}
                         onChange={this.handleFormChange.bind(this,
                             name)}
                         key={name}/>);
      case 'multi-select':
        return (
            <InputSelect value={this.state.data[name].data}
                         options={options}
                         label={label}
                         multi
                         onChange={this.handleMultiSelectChange.bind(this,
                             name)}
                         key={name}/>
        );
      case 'multi-file':
        return (
            <InputFile value={this.state.data[name].data}
                       multiple
                       label={label}
                       key={name}
                       sampleFile={sample}
                       onChange={this.handleFormChange.bind(this, name)}
            />
        );

      case 'translated-field-file':
      case 'translated-field-text':
        return this.renderTranslatedField(name, type, label, labelWhenEmpty,
            sample);
      default:
        return (
            <Input type={type}
                   value={this.state.data[name].data}
                   label={label}
                   onChange={this.handleFormChange.bind(this, name)}
                   key={name}/>
        );
    }
  }

  render() {
    return (
        <Panel title={this.props.block.title}
               key={this.props.block.slug + this.props.blueprint.blueprintId}
        >
          {(() => {
            return this.props.block.fields.map((field) => {
              return this.renderField(field);
            });
          })()}
          <BlueprintPanelFooter
              submitting={this.props.submitting}
              onNext={this.props.onNext ? this.handleNext : null}
              onBack={this.props.onBack}
              onSubmit={this.props.onSubmit ? this.handleSubmit : null}
          />
        </Panel>
    );
  }
}

export default connect((state, props) => {
  return {
    blueprint: Object.assign({}, props.blueprint || {},
        (state.blueprints.current || {})),
  };
})(BlueprintSubmitPanel);


// WEBPACK FOOTER //
// ./src/containers/BlueprintSubmitPanel.js